// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"899":"cab3ad6b25417be3","966":"10aaddd6633bf72d"}[chunkId] + ".js";
};